import type { ColumnDef } from '@tanstack/react-table';
import { ChevronRight } from 'lucide-react';

import type { ClientListItem } from '@/entities/client';

import { getClientCompletion } from '../../../lib/get-client-completion';
import { ClientTableCompletionProgress } from './client-table-columns/client-table-completion-progress';
import { ClientTableMissingFieldsCell } from './client-table-columns/client-table-missing-fields-cell';
import { ClientTableNameCell } from './client-table-columns/client-table-name-cell';

export const clientTableColumns: ColumnDef<ClientListItem>[] = [
    {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => {
            const name = row.getValue('name') as string;
            const { percentage } = getClientCompletion(row.original);

            return (
                <ClientTableNameCell name={name}>
                    <ClientTableCompletionProgress
                        value={percentage}
                        size={24}
                        strokeWidth={2}
                        showValue={false}
                    />
                </ClientTableNameCell>
            );
        },
        meta: {
            className: 'table-cell pl-6 xs:pl-2',
        },
    },
    {
        accessorKey: 'lastSession',
        header: 'Last Session',
        cell: ({ row }) => {
            const lastSession = row.getValue('lastSession') as Date | null;
            if (!lastSession) return null;

            const date = new Date(lastSession);
            const formatted = date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: '2-digit',
            });

            return <span className="underline">{formatted}</span>;
        },
        meta: {
            className: 'table-cell',
        },
    },
    {
        header: 'Profile',
        cell: ({ row }) => {
            const { percentage, missing } = getClientCompletion(row.original);
            return (
                <div className="flex items-center gap-3 h-[36px] py-2 w-full min-w-0">
                    <ClientTableCompletionProgress
                        value={percentage}
                        size={32}
                        strokeWidth={3}
                        showValue={false}
                        className="flex-shrink-0"
                    />
                    <div className="flex flex-col min-w-0 flex-1 overflow-hidden">
                        <div className="text-sm font-medium">{percentage}%</div>
                        {missing.length > 0 && <ClientTableMissingFieldsCell missing={missing} />}
                    </div>
                </div>
            );
        },
        meta: {
            className: 'table-cell profile-cell',
        },
    },
    {
        id: 'action',
        header: '',
        cell: () => {
            return (
                <div className="flex justify-center items-center h-[36px]">
                    <ChevronRight className="w-4 h-4 text-muted-foreground" />
                </div>
            );
        },
        meta: {
            className: 'table-cell action-cell',
        },
    },
];
